import { z } from 'zod';
export const relationshipsNoteMergeFieldsCapability = 'relationships.note-merge-fields.v1';
export const relationshipsNoteMergeFieldsProviderId = 'relationships.server.note-merge-fields';
export const relationshipsNoteMergeFieldsSlot = 'projects.note-merge-fields';
const identity = z.string().uuid();
const timestamp = z.string().datetime({ offset: true });
const nullableText = (max) => z.string().max(max).nullable();
// Deliberate scalar aliases for the retained CRM1 snippet syntax; no nested records.
export const relationshipsContactMergeFieldsSchema = z.strictObject({
    id: identity, org_id: identity.nullable(), first_name: z.string().min(1).max(120),
    last_name: nullableText(120), email: z.string().email().max(320).nullable(),
    phone: nullableText(60), phone_alt: nullableText(60), title: nullableText(160),
    type: z.enum(['customer', 'adjuster', 'agent', 'property_manager', 'vendor', 'internal', 'other']),
    status: z.enum(['active', 'difficult', 'vip', 'inactive']), notes: nullableText(10_000),
    notify_sms: z.boolean(), notify_email: z.boolean(), created_at: timestamp, updated_at: timestamp,
});
export const relationshipsOrganizationMergeFieldsSchema = z.strictObject({
    id: identity, name: z.string().min(1).max(240),
    type: z.enum(['customer', 'insurance', 'vendor', 'adjuster', 'property_manager', 'other']),
    phone: nullableText(60), email: z.string().email().max(320).nullable(),
    address: nullableText(481), city: nullableText(120), state: nullableText(120),
    zip: nullableText(20), website: nullableText(320),
    status: z.enum(['active', 'difficult', 'preferred', 'inactive']), notes: nullableText(10_000),
    created_at: timestamp, updated_at: timestamp,
});
export const relationshipsNoteMergeFieldsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('projects'),
    requestedCapability: z.literal(relationshipsNoteMergeFieldsCapability),
    resourceType: z.literal('projects.project'),
    requestId: identity, projectId: identity, projectRevision: z.number().int().positive(),
    contactId: identity.nullable(), organizationId: identity.nullable(),
});
export const relationshipsNoteMergeFieldsResponseSchema = z.strictObject({
    contractVersion: z.literal(relationshipsNoteMergeFieldsCapability),
    providerId: z.literal(relationshipsNoteMergeFieldsProviderId),
    tenantId: identity, requestId: identity, projectId: identity,
    projectRevision: z.number().int().positive(),
    contactId: identity.nullable(), organizationId: identity.nullable(),
    privateDetailsVisible: z.boolean(),
    contact: relationshipsContactMergeFieldsSchema.nullable(),
    organization: relationshipsOrganizationMergeFieldsSchema.nullable(),
}).superRefine((value, context) => {
    if (value.contact !== null && value.contact.id !== value.contactId) {
        context.addIssue({ code: 'custom', path: ['contact'], message: 'Contact identity mismatch.' });
    }
    if (value.organization !== null && value.organization.id !== value.organizationId) {
        context.addIssue({ code: 'custom', path: ['organization'], message: 'Organization identity mismatch.' });
    }
    if (!value.privateDetailsVisible &&
        (value.contact?.email != null || value.contact?.phone != null || value.contact?.phone_alt != null ||
            value.organization?.email != null || value.organization?.phone != null)) {
        context.addIssue({ code: 'custom', message: 'Private merge fields must be redacted.' });
    }
});
//# sourceMappingURL=relationships-note-merge-fields.contract.js.map